import { AlertService } from './../../api/alert.service';
import { environment } from '@app/env';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
/* Types */
import { RoleValues } from '@api/types';
/* Services */
import { AuthService } from './auth.service';
import { ProfileService } from '../../shared/services/profile.service';
import { ErrorService } from '../../api/error.service';
import { ApiService } from '@api/service';
import { AppPopoversService } from '../app-popovers/app-popovers.service';
import { map, take } from 'rxjs/operators';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(
    private authService: AuthService,
    private api: ApiService,
    private router: Router,
    private profileService: ProfileService,
    private alertService: AlertService,
    private errorService: ErrorService,
    private appPopoversService: AppPopoversService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const url: string = state.url;
    const forceFetch: boolean = !!route.queryParams['forceFetch'];
    const popover: string = route.queryParams['popover'] || null;
    const giftId: string = route.queryParams['giftId'];
    // const firstLogin: string = route.queryParams['firstLogin'];
    const acq_campaign: string = route.queryParams['acq_campaign'];
    if (giftId) {
      localStorage.setItem('giftId', giftId);
    }
    if (acq_campaign) {
      localStorage.setItem('acq_campaign', acq_campaign);
    }
    const firstLogin = localStorage.getItem('firstLogin');
    if (firstLogin) {
      ga('send', { hitType: 'pageview', page: '/onboarding-step-9', title: 'Onboarding - Complete' });
      localStorage.removeItem('firstLogin');
    }
    return this.checkLogin(url, forceFetch, popover);
  }
  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.canActivate(route, state);
  }
  checkLogin(url: string, forceFetch: boolean, popover: string): Observable<boolean> {
    const fallbackUrl = '/welcome';

    let customReqParams: any = {};
    if (popover) {
      customReqParams = { queryParams: { popover: popover } };
    }
    return this.profileService.whoAmI(forceFetch).pipe(
      map(
        user => {
          // No User check
          if (!user) {
            return false;
          }

          // If user logged in without filling signup (send user to signup)
          if (user.role === RoleValues.NO_PROFILE) {
            this.router.navigate(['/welcome/signup'], customReqParams);
            return false;
          }
          // If user completed onboarding without auth, send user to auth (temporary onboarding)
          if (user.role === RoleValues.NO_EMAIL && url !== '/login') {
            this.router.navigate(['/login'], customReqParams);
            return false;
          }
          // Allow access if user NORMAL or ADMIN
          if (user.role === RoleValues.NORMAL) {
            const giftId: string = localStorage.getItem('giftId') || null;
            if (giftId) {
              localStorage.removeItem('giftId');
              this.appPopoversService.open('confirmGiftModalContent', () => {
                this.redeemGift(giftId);
                this.appPopoversService.close('confirmGiftModalContent');
              });
            }
            return true;
          } else if (user.role === RoleValues.ADMIN) {
            if (!environment.isCordova) {
              window.location.href = window.location.origin + '/admin/index.html';
            }
            return true;
          } else {
            this.router.navigate([fallbackUrl], customReqParams);
            return false;
          }
        },
        err => {
          this.router.navigate([fallbackUrl]);
          return false;
        }
      ),
      take(1)
    );
  }
  redeemGift(giftId) {
    this.api.maksekeskus.redeemGift({ giftId }).subscribe(res => {
      this.alertService.addAlert(
        this.alertService.createCustomAlertObj(environment.langShort === 'ET' ? 'Kingitus aktiveeritud' : 'Gift applied', 'success', 3000)
      );
    });
  }
}
